import { BookingStates } from '../../../../../constants/booking-states';

export const getBookingSummaryTitle = (booking, intl) => {
  let title = '';

  if (booking.obj_state === BookingStates.INQUIRED) {
    title = intl.formatMessage({
      id: 'inbox.message_main.inquiry_details',
      defaultMessage: 'Inquiry details'
    });
  } else if (
    booking.obj_state === BookingStates.OFFER_SUBMITTED ||
    booking.obj_state === BookingStates.HOST_UPDATE_REQUESTED
  ) {
    title = intl.formatMessage({
      id: 'inbox.message_main.offer_details',
      defaultMessage: 'Offer details'
    });
  } else {
    title = intl.formatMessage({
      id: 'inbox.message_main.booking_details',
      defaultMessage: 'Booking details'
    });
  }

  return title;
};
